import { MockPolicyId } from "../mockPolicies";
import { insuranceBillPastDue } from "../builders/createInsuranceBill";
import { getHdc1Dot0Membership } from "../builders/getHdc1Dot0Membership";
import { getMockPolicies } from "../builders/getMockPolicies";
import { legacyCanadaVipMember } from "../mockMembers";
import { cigPastDueBill } from "../builders/createCigBill";

import { MockPersona } from "./mockPersonas.types";

const canadianPolicies: MockPolicyId[] = ["dc101"];

export const dukeCaboom: MockPersona = {
  key: "dukeCaboom",
  name: "Duke Caboom",
  description: "🇨🇦 | Single policy with no broker | HDC 1.0 VIP | Bill past due | Auto pay | Email Verified",
  emailVerified: true,
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [cigPastDueBill({ id: "1", productNumber: canadianPolicies[0] })],
      },
      policies: {
        usa: [],
        canada: getMockPolicies(...canadianPolicies),
      },
    },
    hdc: {
      fetch1Dot0Membership: getHdc1Dot0Membership({ ProductCode: "USMEMBVIP" }),
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "duke@caboom.com",
            firstName: "Duke",
            middleName: "",
            lastName: "Caboom",
            mailingAddress: {
              line1: "54 Erie Dr",
              line2: "",
              city: "Montreal",
              state: "QC",
              postalCode: "G1A 0A6",
              country: "CANADA",
            },
            preferredPhone: "5145551212",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000009",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: legacyCanadaVipMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [insuranceBillPastDue({ policyNumber: canadianPolicies[0], id: "1" })],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
